export const aboutContent = {
  hero: {
    title: "About FamilyCast",
    subtitle: "Built by a busy family, for busy families just like yours"
  },
  howItStarted: {
    title: "How It All Started",
    paragraphs: [
      "We're parents. And like you, we were drowning in sticky notes, missed appointments, and the endless question: \"What's for dinner tonight?\"",
      "Our fridge looked like a paper explosion. Our phones were full of unanswered family group texts. And somehow, someone always missed the memo about soccer practice.",
      "So we did what any tech-loving, slightly obsessed parents would do: we built something to fix it. What started as a simple family calendar on an old tablet turned into something bigger—a whole system to keep everyone on the same page.",
      "We gave it a name, added some friendly beaver mascots (because beavers build homes and work together—just like families), and decided other families might love it too.",
      "That's how FamilyCast was born. We're still learning, still building, and definitely still a work in progress (just like parenting). But we're excited to share what we've created and help your family stay organized and connected."
    ]
  },
  whyChoose: {
    title: "Why FamilyCast?",
    items: [
      { text: "Automatic schedule updates", iconName: "TrendingUp" },
      { text: "Everyone sees changes instantly", iconName: "Speed" },
      { text: "Perfect for multi-household families", iconName: "DisplaySettings" },
      { text: "Works with apps you already use", iconName: "Settings" },
      { text: "Always on, always working", iconName: "Support" },
      { text: "Built by parents who use it daily", iconName: "People" }
    ]
  },
  values: {
    title: "What We Believe",
    subtitle: "The principles that guide how we build FamilyCast",
    cards: [
      {
        title: "Family First",
        description: "Families should spend time together, not managing schedules and to-do lists. Technology should help, not add more complexity.",
        iconName: "People"
      },
      {
        title: "Keep It Simple",
        description: "Life is complicated enough. Family organization should be easy—and maybe even a little fun.",
        iconName: "Rocket"
      },
      {
        title: "We've Got Your Back",
        description: "Real support from real people who get it. We're parents too, and we know tech can be frustrating.",
        iconName: "Support"
      }
    ]
  },
  cta: {
    title: "Want to Try It?",
    subtitle: "Join our early access program and help us build something great for families.",
    buttonText: "Get Early Access",
    buttonLink: "/beta"
  }
};
